// @flow

export function replace(url: string) {
  window.location.replace(url);
}

export function assign(url: string) {
  window.location.assign(url);
}
